// @ts-nocheck

import { createSlice } from '@reduxjs/toolkit';
import { BriefingsState } from '@/types/briefings';
import { briefings } from './thunks';

const initialState: BriefingsState = {
  briefings: [],
  currentBriefing: null,
  isLoading: false,
  error: null,
  totalCount: 0,
};

export const briefingsSlice = createSlice({
  name: 'briefings',
  initialState,
  reducers: {
    clearError: state => {
      state.error = null;
    },
    clearCurrentBriefing: state => {
      state.currentBriefing = null;
    },
  },
  extraReducers: builder => {
    builder
      // Get Briefings
      .addCase(briefings.getBriefings.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(briefings.getBriefings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        // Assuming response is array or has briefings array
        state.briefings = Array.isArray(action.payload)
          ? action.payload
          : action.payload.briefings || [];
        state.totalCount = state.briefings.length;
      })
      .addCase(briefings.getBriefings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Get Briefing By ID
      .addCase(briefings.getBriefingById.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(briefings.getBriefingById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.currentBriefing = action.payload;
      })
      .addCase(briefings.getBriefingById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Create Briefing
      .addCase(briefings.createBriefing.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(briefings.createBriefing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.briefings.push(action.payload);
        state.totalCount += 1;
      })
      .addCase(briefings.createBriefing.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Update Briefing
      .addCase(briefings.updateBriefing.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(briefings.updateBriefing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        const index = state.briefings.findIndex(briefing => briefing.id === action.payload.id);
        if (index !== -1) {
          state.briefings[index] = action.payload;
        }
        if (state.currentBriefing?.id === action.payload.id) {
          state.currentBriefing = action.payload;
        }
      })
      .addCase(briefings.updateBriefing.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, clearCurrentBriefing } = briefingsSlice.actions;
export const briefingsReducer = briefingsSlice.reducer;
